import * as XLSX from "xlsx";

const DownloadExcelFile = (data, fileName) => {
  let workbook;

  if (typeof data === "string") {
    // Plain CSV string from API
    workbook = XLSX.read(data, { type: "string" });

  } else if (data instanceof ArrayBuffer) {
    // Binary Excel buffer
    workbook = XLSX.read(data, { type: "array" });

  } else if (data instanceof Uint8Array || Array.isArray(data)) {
    // Converted ArrayBuffer (from Redux serialization)
    workbook = XLSX.read(new Uint8Array(data), { type: "array" });

  } else {
    console.error("Unsupported data format for Excel download");
    return;
  }

  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export default DownloadExcelFile;